require('./style.scss');
let tmpl = require('./main.ejs');
let util = require('f.core.mobile.util');

let Events = require('f.core.event');

let Tab = function() {
    this.tabs = [];
    this.index = 0;
    this.init();
};

Tab.prototype.init = function() {
    this.initDom();
    this.initEvent();
};

Tab.prototype.initDom = function() {
    let div = document.createElement('div');
    div.innerHTML = tmpl({});
    this.elHead = div.children[0];
    this.elBody = div.children[1];
    this.elSlider = this.elBody.querySelector('.c-slider');
    this.elToggle = this.elHead.querySelector('.top');
};

Tab.prototype.initEvent = function() {
    let self = this;
    util.tap(
        this.elHead,
        function(e) {
            let target = e.target;
            if (target.classList.contains('.c-nav__title--active')) {
                return;
            }
            let index = target.dataset.index;
            this.active(index);
        },
        {
            scope: this,
            delegate: '.c-nav__title'
        }
    );

    $(this.elToggle).on('touchend', function() {
        if (this.classList.contains('spread')) {
            self.fold();
        } else {
            self.spread();
        }
        return false;
    });

    this.on('shrink', function(direction) {
        if (direction === 'down') {
            self.fold();
        } else if (direction === 'up') {
            self.spread();
        }
    });
};

Tab.prototype.add = function(title, compontent, type, callback) {
    callback = callback || function() {};
    let index = this.tabs.length;
    this.tabs.push({ compontent: compontent, callback: callback, type: type });

    let tab = document.createElement('div');
    tab.classList.add('c-nav__title');
    if (this.tabs.length === 1) {
        tab.classList.add('c-nav__title--active');
    }
    tab.innerHTML = title;
    tab.dataset.index = index;
    tab.dataset.type = type;
    this.elHead.appendChild(tab);

    let item = document.createElement('div');
    item.classList.add('c-slider__item');
    if (this.tabs.length === 1) {
        item.classList.add('c-slider__item--active');
    }
    if (compontent) {
        compontent.renderTo(item);
    }
    item.dataset.index = index;
    item.dataset.type = type;
    item.id = 'slider_' + type;
    this.elSlider.appendChild(item);
};

Tab.prototype.active = function(index) {
    let activeHead = this.elHead.querySelector('.c-nav__title--active');
    if (activeHead) {
        activeHead.classList.remove('c-nav__title--active');
    }
    this.elHead.querySelectorAll('.c-nav__title')[index].classList.add('c-nav__title--active');
    let activeItem = this.elBody.querySelector('.c-slider__item--active');
    if (activeItem) {
        activeItem.classList.remove('c-slider__item--active');
    }
    this.elBody.querySelectorAll('.c-slider__item')[index].classList.add('c-slider__item--active');
    this.elHead.querySelectorAll('.c-nav__title')[index].classList.remove('c-nav__title_notice');
    let type = this.elBody.querySelectorAll('.c-slider__item')[index].dataset.type;
    this.trigger('change', type);
    // this.tabs[index].callback(this.tabs[index].compontent);
};

Tab.prototype.notice = function(type) {
    console.log(type);
    let elm = this.elHead.querySelector('[data-type="' + type + '"]');
    console.log(elm);
    if (!elm.classList.contains('c-nav__title--active')) {
        elm.classList.add('c-nav__title_notice');
    }
};

Tab.prototype.foldShow = function() {
    this.elToggle.style.display = 'none';
};

Tab.prototype.foldHide = function() {
    this.elToggle.style.display = 'block';
};

Tab.prototype.fold = function() {
    this.elToggle.classList.add('fold');
    this.elToggle.classList.remove('spread');
    this.trigger('fold');
};

Tab.prototype.spread = function() {
    this.elToggle.classList.add('spread');
    this.elToggle.classList.remove('fold');
    this.trigger('spread');
};

Tab.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.elHead);
    parentNode.appendChild(this.elBody);
};

Events.mixTo(Tab);

module.exports = Tab;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.tab.mobile/app/index.js